import { ChevronDown, MapPin } from 'lucide-react';

import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

import { useIsMobile } from '@/hooks';

import { useChangeLocationMutation } from '@/mutations';

import { SidebarMenuProps } from '@/types';

export const LocationSwitcher = (props: SidebarMenuProps['location_props']) => {
  const { current_location_id, locations, url } = props;
  const isMobile = useIsMobile();

  const currentLocation = (locations || []).find(
    (location) => location.id === current_location_id,
  );

  const { mutate: changeLocation, isPending: isChangeLocationPending } =
    useChangeLocationMutation();

  const onLocationChange = (locationId: number) => {
    if (!url || locationId === current_location_id) {
      return;
    }

    changeLocation(
      {
        locationId,
        url,
      },
      {
        onSuccess: (res) => {
          if (res?.status === 'ok') {
            window.location.reload();
          }
        },
      },
    );
  };

  if (!locations || locations.length === 0) {
    return null;
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        asChild
        className="focus-visible:outline-none"
      >
        <Button
          variant="ghost"
          size="sm"
          disabled={isChangeLocationPending}
          className="group/trigger max-w-64"
        >
          <MapPin className="text-muted-foreground" />
          <span className="truncate">{currentLocation?.name || ''}</span>
          <ChevronDown className="transition-transform duration-200 group-data-[state=open]/trigger:rotate-180" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align={isMobile ? 'center' : 'start'}
        collisionPadding={8}
        className="bg-popover text-popover-foreground min-w-(--radix-dropdown-menu-trigger-width)"
      >
        {locations.map((location) => (
          <DropdownMenuCheckboxItem
            key={location.id}
            className="cursor-pointer"
            checked={location.id === current_location_id}
            onCheckedChange={() => {
              onLocationChange(location.id);
            }}
            disabled={isChangeLocationPending}
          >
            {location.name}
          </DropdownMenuCheckboxItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
